var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCPlusPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 84 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2, .cls-3, .cls-4, .cls-5 {\n        fill-rule: evenodd;\n      }\n\n      .cls-2, .cls-6 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        fill: #c04062;\n      }\n\n      .cls-4 {\n        fill: #e39c97;\n      }\n\n      .cls-5 {\n        fill: #ce4563;\n      }\n\n      .cls-7 {\n        fill: #fef0f0;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: -1.9,
    y: -2.1,
    width: 87.8,
    height: 99.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4803.7-375.5h2500v2500h-2500V-375.5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.9,
    y: 0.8,
    width: 82.2,
    height: 94.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2-2",
    className: "cls-3",
    d: "M39.8,5.9c1.4-.8,3.1-.8,4.5,0,6.8,3.8,27.3,15.4,34.2,19.2,1.4.8,2.2,2.2,2.2,3.8v38.4c0,1.5-.8,3-2.2,3.8-6.8,3.8-27.3,15.4-34.2,19.2-1.4.8-3.1.8-4.5,0-6.8-3.8-27.3-15.4-34.2-19.2-1.4-.8-2.2-2.2-2.2-3.8V28.8c0-1.5.8-3,2.2-3.8,6.8-3.8,27.4-15.4,34.2-19.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4-2",
    className: "cls-4",
    d: "M4.1,69.2c-.5-.7-.6-1.4-.6-2.3V28.7c0-1.5.8-3,2.2-3.7,6.8-3.8,27.3-15.3,34.1-19.1,1.4-.8,3.2-.8,4.6,0,6.8,3.8,27.2,15.2,34,19,.5.3,1,.7,1.3,1.2L4.1,69.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6-2",
    className: "cls-2",
    d: "M42.1,19.5c15.7,0,28.5,12.8,28.5,28.5s-12.8,28.5-28.5,28.5-28.5-12.8-28.5-28.5,12.8-28.5,28.5-28.5h0ZM42.1,33.8c7.9,0,14.2,6.4,14.2,14.2s-6.4,14.2-14.2,14.2-14.2-6.4-14.2-14.2,6.4-14.2,14.2-14.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path8-2",
    className: "cls-5",
    d: "M79.7,26.1c1,1,1,2.5,1,3.6v37.4c0,.8-.3,1.7-.7,2.3l-38.8-21.3,38.4-21.9h.1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "63.8 45.8 59.9 45.8 59.9 41.9 56.1 41.9 56.1 45.8 52.2 45.8 52.2 49.6 56.1 49.6 56.1 53.5 59.9 53.5 59.9 49.6 63.8 49.6 63.8 45.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "78.2 45.8 74.4 45.8 74.4 41.9 70.5 41.9 70.5 45.8 66.7 45.8 66.7 49.6 70.5 49.6 70.5 53.5 74.4 53.5 74.4 49.6 78.2 49.6 78.2 45.8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCPlusPlus);
export default __webpack_public_path__ + "static/media/CPlusPlus.2683aea63f85903dbf5c05cedd041376.svg";
export { ForwardRef as ReactComponent };